import { ScreenOptionsManager } from '../../ScreenOptionsManager';
import { useAppSelector } from '../../../../Redux/store';

export const HomeScreen = () => {
    const { gameUrl } = useAppSelector(state => ({
        optionSelected: state.screenInteractions.optionSelected ?? 0,
        gameUrl: state.game.gameUrl,
    }))

    const gameOptions = gameUrl ? ['Play Game', 'Game Options'] : ['Play Demo', 'Insert Game'];
    return (
        <div className="h-full flex flex-col justify-center items-center">
            <img src='./wowboi-logo.png' className="w-[180px] max-w-[180px] mb-6" alt="" />
            <div className="w-[74%] flex flex-wrap justify-between p-y-2 gap-x-2 gap-y-2">
                <ScreenOptionsManager options={[...gameOptions, 'About', 'Developer Guide', 'RoadMap', 'cartridge one', 'Other Links']} />
            </div>
        </div>
    )
}

// const ['D']